import { render } from "./DesignerView.vue?vue&type=template&id=03afce64&scoped=true&ts=true"
import script from "./DesignerView.vue?vue&type=script&lang=ts"
export * from "./DesignerView.vue?vue&type=script&lang=ts"

import "./DesignerView.vue?vue&type=style&index=0&id=03afce64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03afce64"]])

export default __exports__